export const HYDROGEN_FUEL_DATA_FETCH = 'HYDROGEN_FUEL_DATA_FETCH';
export const HYDROGEN_MEASUREMENT_YEARS_FETCH =
  'HYDROGEN_MEASUREMENT_YEARS_FETCH';
export const HYDROGEN_MEASUREMENT_DATA_HISTORY_FOR_YEAR_FETCH =
  'HYDROGEN_MEASUREMENT_DATA_HISTORY_FOR_YEAR_FETCH';
export const SELECT_YEAR = 'SELECT_YEAR';
export const HYDROGEN_ISSUE_GOS = 'HYDROGEN_ISSUE_GOS';
